import Chart from "react-apexcharts";

export default function PieCentrosCusto({ data }) {
  const centros = Object.keys(data?.totalPorCentroResponsabilidade || {});
  const valoresCentros = Object.values(data?.totalPorCentroResponsabilidade || {});

  const options = {
    chart: {
      type: "pie",
    },
    labels: centros,
    legend: {
      position: "top",
      fontSize: "12px",
      labels: { colors: "#333" },
    },
    tooltip: {
      y: {
        formatter: (value) =>
          Number(value).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          }),
      },
    },
    responsive: [
      {
        breakpoint: 768,
        options: {
          legend: { position: "bottom" },
        },
      },
    ],
  };

  const series = valoresCentros;

  return (
    <div className="bg-card border border-border rounded-2xl shadow-soft">
      <h2 className="p-4 text-xl font-display font-bold mb-4 text-foreground">Total por Centro de Responsabilidade</h2>
      <Chart options={options} series={series} type="pie" />
    </div>
  );
}
